import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  CompanyName,
  DataTable,
  LinkedTableRow,
  NoteTooltip
} from "MODULES/shared/components";
import { shortDateYY } from "LIB/formatters/date";
import { miniTable } from "MODULES/shared/decorators";
import api from "APP_ROOT/api";
import { withRouter } from "react-router";
import withSubscription from "MODULES/Subscription/withSubscription";
import { getConditionAbbrev } from "MODULES/RepairOrders/constants";
import StatusBadge from "MODULES/RepairOrders/components/Detail/LineItems/StatusBadges";
import { getCap } from "MODULES/RepairOrders/helpers";
import { fromJS } from "immutable";
import { dollars } from "LIB/formatters/currency";

export class Table extends Component {
  static propTypes = {
    results: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number.isRequired,
        created_at: PropTypes.string.isRequired,
        company: PropTypes.shape({ name: PropTypes.string }),
        buyer: PropTypes.shape({ full_name: PropTypes.string }),
        condition: PropTypes.string.isRequired,
        quantity: PropTypes.number.isRequired,
        cost: PropTypes.string
      })
    ).isRequired,
    loading: PropTypes.bool.isRequired
  };

  renderRow = (lineItem, i) => {
    const cap = getCap(fromJS(lineItem));

    return (
      <LinkedTableRow
        to={`/repair-orders/${lineItem.repair_order_uuid}`}
        key={i}
      >
        <td>{i + 1}</td>
        <td className={cap}>{shortDateYY(lineItem.created_at)}</td>
        <td className="text-nowrap">
          <CompanyName flattenedCompany={lineItem} truncateAt={18} />
        </td>
        <td>{lineItem.original_serial_number || lineItem.serial_number}</td>
        <td>
          {getConditionAbbrev(
            lineItem.condition_received || lineItem.condition_sent
          )}
        </td>
        <td className="text-nowrap">
          <StatusBadge lineItem={lineItem} shouldAbbrev />
          {lineItem.inventory &&
            lineItem.inventory.status === "sales_order_created" && (
              <NoteTooltip
                placement="right"
                icon="fa-paper-plane"
                note="Pending Sale"
              />
            )}
        </td>
        <td>{shortDateYY(lineItem.expected_date)}</td>
        <td className="text-right">{dollars(lineItem.subtotal)}</td>
      </LinkedTableRow>
    );
  };

  render() {
    const { loading, results } = this.props;

    return (
      <DataTable.Mini loading={loading} numbered>
        <DataTable.Head>
          <th />
          <th>Date</th>
          <th>Repair Station</th>
          <th>Serial #</th>
          <th>CD</th>
          <th>Status</th>
          <th>Exp Date</th>
          <th className="text-right">Total</th>
        </DataTable.Head>
        <DataTable.Body>{results.map(this.renderRow)}</DataTable.Body>
      </DataTable.Mini>
    );
  }
}

const withResults = miniTable(({ match }, params) =>
  api.parts.repairOrderLineItems.search(match.params.id, params)
);

export default withRouter(
  withResults(withSubscription("RepairOrderLineItem")(Table))
);



// WEBPACK FOOTER //
// ./app/modules/parts/components/Detail/RepairOrders/Table.jsx